/**
 * The one type-style reader for apps/web's prose pages.
 *
 * CLAUDE.md: "never hardcode a colour, size, or duration" — so a component that wants
 * a font size asks the theme for a role (`type.body`, `type.quiet`) and this turns the
 * role into CSS. It lived inside `MarketingPage.tsx` as a private helper until the
 * privacy and support pages needed the identical mapping; three copies of it is how the
 * three pages would come to disagree about line height.
 */
import type { CSSProperties } from 'react';

export type TypeRole = {
  fontSize: number;
  lineHeight: number;
  fontWeight: string;
  letterSpacing: number;
};

export function text(style: TypeRole): CSSProperties {
  return {
    fontSize: style.fontSize,
    lineHeight: `${style.lineHeight}px`,
    fontWeight: style.fontWeight as CSSProperties['fontWeight'],
    letterSpacing: style.letterSpacing,
  };
}
